import 'magnific-popup';
require( 'owl.carousel' );

import nav from './modules/nav';
import home_music from './modules/home_music';
import home_videos from './modules/home_videos';
import home_photos from './modules/home_photos';
import home_tour from './modules/home_tour';
import tour from './modules/tour';
import photos from './modules/photos';

$(document).ready(function($) {

  nav();
  
  if ($('body').hasClass('page-template-home')) {
    home_music();
    home_videos();
    home_photos();
    home_tour();
  }

  if ($('body').hasClass('page-template-tour')) {
    tour();
  }

  if ($('body').hasClass('page-template-photos')) {
    photos();
  }

});